import React, { Component } from "react";
import { getCMS } from "../services/cmsService";

export class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cmsData: [],

      enquiry_name: "",
      enquiry_email: "",
      enquiry_mobile: "",
      enquiry_subject: "",
      enquiry_services: "",
      enquiry_message: "",

      loading: false,
      successMessage: "",
      errorMessage: "",
    };
  }

  async componentDidMount() {
    try {
      const data = await getCMS("contact");

      this.setState({
        cmsData: data || [],
      });
    } catch (error) {
      console.log(error);
    }
  }

  getContentByType = (type) => {
    return this.state.cmsData.find(
      (item) => item.content_type === String(type)
    );
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({
      loading: true,
      successMessage: "",
      errorMessage: "",
    });

    try {
      const formData = new FormData();

      formData.append(
        "enquiry_name",
        this.state.enquiry_name
      );

      formData.append(
        "enquiry_email",
        this.state.enquiry_email
      );

      formData.append(
        "enquiry_mobile",
        this.state.enquiry_mobile
      );

      formData.append(
        "enquiry_subject",
        this.state.enquiry_subject
      );

      formData.append(
        "enquiry_services",
        this.state.enquiry_services
      );

      formData.append(
        "enquiry_message",
        this.state.enquiry_message
      );

      const response = await fetch(
        "https://idealtechnoride.in/api/main/add/contact",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.text();

      if (response.ok) {
        this.setState({
          enquiry_name: "",
          enquiry_email: "",
          enquiry_mobile: "",
          enquiry_subject: "",
          enquiry_services: "",
          enquiry_message: "",

          loading: false,
          successMessage:
            result || "Enquiry submitted successfully.",
        });
      } else {
        this.setState({
          loading: false,
          errorMessage:
            "Failed to submit enquiry.",
        });
      }
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
        errorMessage:
          "Something went wrong. Please try again.",
      });
    }
  };

  render() {
    const heading = this.getContentByType(9);
    const title = this.getContentByType(2);
    const description = this.getContentByType(3);

    return (
      <div>
        <div className="container-fluid py-5">
          <div className="container">
            <div
              className="text-center wow fadeIn"
              data-wow-delay="0.1s"
            >
              <h1 className="mb-5">
                <span className="text-uppercase bg-primary text-white rounded px-2">
                  {heading?.content_title || "CONTACT"}
                </span>{" "}
                {title?.content_title || "US"}
              </h1>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div
                  className="wow fadeIn"
                  data-wow-delay="0.2s"
                >
                  <h4 className="text-center mb-4">
                    {description?.content_paragraph ||
                      "Have a question or need a digital solution? Our team is ready to help you grow your business."}
                  </h4>

                  {this.state.successMessage && (
                    <div className="alert alert-success">
                      {this.state.successMessage}
                    </div>
                  )}

                  {this.state.errorMessage && (
                    <div className="alert alert-danger">
                      {this.state.errorMessage}
                    </div>
                  )}

                  <form
                    onSubmit={this.handleSubmit}
                  >
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            name="enquiry_name"
                            placeholder="Your Name"
                            value={
                              this.state.enquiry_name
                            }
                            onChange={
                              this.handleChange
                            }
                            required
                          />
                          <label>
                            Your Name *
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="form-floating">
                          <input
                            type="email"
                            className="form-control"
                            name="enquiry_email"
                            placeholder="Your Email"
                            value={
                              this.state.enquiry_email
                            }
                            onChange={
                              this.handleChange
                            }
                            required
                          />
                          <label>
                            Your Email *
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            name="enquiry_mobile"
                            placeholder="Mobile"
                            value={
                              this.state.enquiry_mobile
                            }
                            onChange={
                              this.handleChange
                            }
                            required
                          />
                          <label>
                            Mobile *
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            name="enquiry_subject"
                            placeholder="Subject"
                            value={
                              this.state.enquiry_subject
                            }
                            onChange={
                              this.handleChange
                            }
                          />
                          <label>
                            Subject
                          </label>
                        </div>
                      </div>

                      <div className="col-12 mb-3">
                        <div className="form-floating">
                          <select
                            className="form-select"
                            name="enquiry_services"
                            value={
                              this.state
                                .enquiry_services
                            }
                            onChange={
                              this.handleChange
                            }
                            required
                          >
                            <option value="">
                              Select Service
                            </option>

                            <option value="Website Development">
                              Website Development
                            </option>

                            <option value="Mobile App Development">
                              Mobile App Development
                            </option>

                            <option value="Digital Marketing">
                              Digital Marketing
                            </option>

                            <option value="SEO">
                              SEO
                            </option>

                            <option value="UI/UX Design">
                              UI/UX Design
                            </option>

                            <option value="Custom Software Development">
                              Custom Software
                              Development
                            </option>
                          </select>

                          <label>
                            Select Service *
                          </label>
                        </div>
                      </div>

                      <div className="col-12 mb-3">
                        <div className="form-floating">
                          <textarea
                            className="form-control"
                            name="enquiry_message"
                            placeholder="Message"
                            style={{
                              height: "165px",
                            }}
                            value={
                              this.state
                                .enquiry_message
                            }
                            onChange={
                              this.handleChange
                            }
                            required
                          ></textarea>

                          <label>
                            Leave a message here *
                          </label>
                        </div>
                      </div>

                      <div className="col-12">
                        <button
                          className="btn btn-primary w-100 py-3"
                          type="submit"
                          disabled={
                            this.state.loading
                          }
                        >
                          {this.state.loading
                            ? "Submitting..."
                            : "Get Free Consultation"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactUs;